export enum CookieName {
    ShopperToken = 'shopper-token',
    ShopperRefreshToken = 'shopper-refresh-token',
    ShopperRefreshExtendedToken = 'shopper-refresh-token-extended',
    DWSID = 'dwsid',
    FavoriteStore = 'favStore',
    SelectedDeliveryStore = 'estoreSelectedStore',
    RedirectLocale = 'redirectLocale',
    EffectiveDate = 'effectiveDate',
    GuestWishlistProductId = 'guestWishlistedProduct',
    ColorSetting = 'colorSetting',
    PotionGuestId = 'potion_guest_id',
    Reco = 'reco',
}
